import React from "react";

export const ObjectContext = React.createContext({});